document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-discount-toggle]');
  if (toggle && !toggle.closest('cart-drawer')) {
    var wrap = toggle.closest('.cart-discount');
    var form = wrap && wrap.querySelector('[data-discount-form]');
    if (form) {
      form.hidden = !form.hidden;
      if (!form.hidden) {
        var input = form.querySelector('[data-discount-input]');
        if (input) input.focus();
      }
    }
    return;
  }

  var apply = event.target.closest('[data-discount-apply]');
  if (apply && !apply.closest('cart-drawer')) {
    var wrap2 = apply.closest('.cart-discount');
    var input2 = wrap2 && wrap2.querySelector('[data-discount-input]');
    if (input2 && input2.value.trim()) {
      var code = input2.value.trim();
      var originalText = apply.textContent;
      apply.disabled = true;
      apply.textContent = '...';

      var footerElBefore = document.getElementById('main-cart-footer');
      // The main-cart-footer section is included in templates/cart.json under the key
      // "cart-footer", so Shopify assigns it a dynamic runtime section id (exposed here as
      // {{ section.id }} via the data-id attribute) rather than the plain filename. The
      // Section Rendering API only returns populated blocks when queried by that exact id.
      var sectionId = footerElBefore ? footerElBefore.getAttribute('data-id') || 'main-cart-footer' : 'main-cart-footer';

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          discount: code,
          sections: sectionId + ',cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          apply.disabled = false;
          apply.textContent = originalText;

          if (data.sections) {
            var footerEl = document.getElementById('main-cart-footer');
            if (footerEl && data.sections[sectionId]) {
              var parsedDoc = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
              var parsed = parsedDoc.getElementById('main-cart-footer');
              if (parsed) {
                footerEl.innerHTML = parsed.innerHTML;
              }
            }

            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && data.sections['cart-icon-bubble']) {
              var parsedBubble = new DOMParser()
                .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section');
              if (parsedBubble) bubble.innerHTML = parsedBubble.innerHTML;
            }
          }
        })
        .catch(function () {
          apply.disabled = false;
          apply.textContent = originalText;
        });
    }
    return;
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter') return;
  var input = event.target.closest('[data-discount-input]');
  if (!input || input.closest('cart-drawer')) return;
  event.preventDefault();
  var wrap = input.closest('.cart-discount');
  var applyBtn = wrap && wrap.querySelector('[data-discount-apply]');
  if (applyBtn) applyBtn.click();
});
